import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from "@material-ui/core/styles";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  TextoDescPesquisa,
  FormPesquisa,
  DoisCampos,
  CampoFormBusca,
  CampoFormCadastro,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  DescCampo,
  ModalEvento,
  BgModal,
  ItemListaBusca,
  ClienteProdutoSelecionado,
  DivFilePesquisa,
  BtVoltar
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function IndiretoPesquisa(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Indireto / Pesquisa")
    }
  }, []);

  const myinput = useRef();
  const [ PrecoPao, setPrecoPao ] = useState(0);
  const [ ClienteSelecionado, setClienteSelecionado ] = useState(false);
  const [ ProdutoSelecionado, setProdutoSelecionado ] = useState(false);
  const [ TextoAguarde, setTextoAguarde ] = useState(false);
  const [ ClienteNome, setClienteNome ] = useState("");
  const [ ClienteCPNJ, setClienteCPNJ ] = useState("");
  const [ ClienteSAP, setClienteSAP ] = useState("");
  const [ ClienteID, setClienteID ] = useState("");
  const [ ProdutoNome, setProdutoNome ] = useState("");
  const [ ProdutoMarca, setProdutoMarca ] = useState("");
  const [ ProdutoPeso, setProdutoPeso ] = useState("");
  const [ ProdutoCategoria, setProdutoCategoria ] = useState("");
  const [ ProdutoID, setProdutoID ] = useState("");
  const [ LocalCompra, setLocalCompra ] = useState("");
  const [ ClienteMostra, setClienteMostra ] = useState(false);
  const [ DadosClienteFlatlist, setDadosClienteFlatlist ] = useState([]);
  const [ ProdutoMostra, setProdutoMostra ] = useState(false);
  const [ DadosProdutoFlatlist, setDadosProdutoFlatlist ] = useState([]);
  const [ Cargo, setCargo ] = useState([]);
  const [ CarregandoBusca, setCarregandoBusca ] = useState(true);
  const [ ProdNome, setProdNome ] = useState("");
  const [ NFNome, setNFNome ] = useState("");
  const [ PDVNome, setPDVNome ] = useState("");

  const [ ListaCanalCliente, setListaCanalCliente ] = useState([]);
  const [ CanalCliente, setCanalCliente ] = useState('');

  const onSubmit = async (data, e) => {  

    if(ClienteSelecionado == null || ClienteSelecionado == ''){
      AlertForm('Você precisa selecionar um cliente');
      e.preventDefault();
      return false
    } 

    if(CanalCliente == null || CanalCliente == ''){
      AlertForm('Selecione o canal do cliente');
      e.preventDefault();
      return false
    } 

    if(ProdutoSelecionado == null || ProdutoSelecionado == ''){
      AlertForm('Você precisa selecionar um produto');
      e.preventDefault();
      return false
    } 

    if(PrecoPao == 0){
      AlertForm('Preço unitário é um campo obrigatório');
      e.preventDefault();
      return false
    } 
    
    
    setTextoAguarde(true);
    
    // console.log( ClienteNome )
    // console.log( ClienteCPNJ )
    // console.log( ClienteSAP )
    // console.log( ClienteID )
    // console.log( data.c_cargo )
    // console.log( data.c_data )
    // console.log( ProdutoNome )
    // console.log( ProdutoMarca )
    // console.log( ProdutoCategoria )
    // console.log( data.c_qnt )
    // console.log( PrecoPao )
    // console.log( LocalCompra )




    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "lojaId": ClienteID,
      "produtoId": ProdutoID,
      "canalCliente": CanalCliente,
      "precoUnitario": PrecoPao
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Pesquisa/SalvaIndireto`, requestOptions)
      .then(response => response.json())
      .then(result => {

        console.log(result)
        
        if(result.sucesso === true) {

            setTextoAguarde(false);

            AlertForm('Sua pesquisa foi cadastrada com sucesso!');
            setProdutoID("");
            setCanalCliente("");
            setPrecoPao(0);
            setProdutoSelecionado(false);

        } else {

            setTextoAguarde(false);
            AlertForm('Sua pesquisa não foi cadastrada. Por favor, tente novamente. ' + result.mensagem);

        }

      
      })
      .catch(error => console.log('error', error));





  };

  const BuscaCliente = async (data, e) => { 
      
    // console.log(data);

    if(data.c_razaosap == undefined || data.c_razaosap.length < 5) {
      AlertForm('Você precisa digitar no mínimo 5 dígitos');
      e.preventDefault();
      return false
    }

    setClienteMostra(true);
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Pesquisa/ListarRazaoSap/`+ CPFUser +"/"+data.c_razaosap, requestOptions)
    .then(response => response.json())
    .then(result => {
        console.log(result);
        setCarregandoBusca(false);
        if(result.outEntidades.length > 0) {
        setDadosClienteFlatlist(result.outEntidades);
        }
    })
    .catch(error => console.log('error', error));

  }

  const BuscaIndustria = async (data, e) => { 
      
    // console.log(data);

    if(data.c_industria == undefined || data.c_industria.length < 3) {
      AlertForm('Você precisa digitar no mínimo 3 dígitos');
      e.preventDefault();
      return false
    }

      setProdutoMostra(true);
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Pesquisa/SobreCompra/` + data.c_industria, requestOptions)
    .then(response => response.json())
    .then(result => {
        console.log(result);
        setCarregandoBusca(false);
        if(result.outPesquisaProduto.length > 0) {
          setDadosProdutoFlatlist(result.outPesquisaProduto);
        }
    })
    .catch(error => console.log('error', error));

  }

  const PegaNomeArquivo = async (data, e) => { 
      
    // console.log(data);

    if(data.ProdfileUri.length > 0) {
      setProdNome(data.ProdfileUri[0]);
    }

    if(data.PDVfileUri.length > 0) {
      setPDVNome(data.PDVfileUri[0]);
    }

    if(data.NFfileUri.length > 0) {
      setNFNome(data.NFfileUri[0]);
    }

  }

  function LoadBusca() {
    return <>
    <div>Carregando...</div>
    </>
  }

  function SelecionaCliente(ClienteNome, ClienteCPNJ, ClienteSAP, ClienteID) {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
    setClienteNome(ClienteNome);
    setClienteCPNJ(ClienteCPNJ);
    setClienteSAP(ClienteSAP);
    setClienteID(ClienteID);
    setClienteSelecionado(true);
    setValue('c_razaosap', '')
  }

  function FecharBuscaCliente() {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
  }

  function FecharBuscaProduto() {
    setProdutoMostra(false);
    setCarregandoBusca(true);
    setDadosProdutoFlatlist([]);
  }

  function SelecionaProduto(ProdutoNome, ProdutoMarca, ProdutoPeso, ProdutoCategoria, ProdutoID) {
    setProdutoMostra(false);
    setCarregandoBusca(true);
    setDadosProdutoFlatlist([]);
    setProdutoNome(ProdutoNome);
    setProdutoMarca(ProdutoMarca);
    setProdutoPeso(ProdutoPeso);
    setProdutoCategoria(ProdutoCategoria);
    setProdutoID(ProdutoID);
    setProdutoSelecionado(true);
    setValue('c_industria', '')
  }

  const renderItem = ( item, index ) => (
    <ItemListaBusca key={index} onClick={()=>SelecionaCliente(item.nome, item.cnpj, item.sap, item.id)}>
        <div className={'NomeCliente'}>{item.nome}</div>
        <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(item.cnpj)}</div>
        <div className={'CNPJSAP'}><span>SAP</span> {item.sap}</div>
    </ItemListaBusca>
  );

  const renderItemProduto = ( item, index ) => (
    <ItemListaBusca key={index} onClick={()=>SelecionaProduto(item.nomeProduto, item.marca, item.peso, item.categoria, item.id)}>
        <div className={'NomeCliente'}>{item.nomeProduto}</div>
        <div className={'MarcaCategoriaPeso'}><span>MARCA</span> {item.marca}</div>
        <div className={'MarcaCategoriaPeso'}><span>CATEGORIA</span> {item.categoria}</div>
        <div className={'MarcaCategoriaPeso'}><span>PESO</span> {item.peso}</div>
    </ItemListaBusca>
  );

  function MostraBuscaCliente(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Busca de clientes</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadBusca />
                    :
                    DadosClienteFlatlist.length > 0 ?
                        DadosClienteFlatlist.map((item, index) => {
                            return renderItem(item, index)
                        })
                    :
                    <div>Nenhum cliente encontrado{'\n'}Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharBuscaCliente()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }

  function MostraProdutoCliente(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Busca de produtos</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadBusca />
                    :
                    DadosProdutoFlatlist.length > 0 ?
                      DadosProdutoFlatlist.map((item, index) => {
                            return renderItemProduto(item, index)
                        })
                    :
                    <div>Nenhum produto encontrado{'\n'}Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharBuscaProduto()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }

  useEffect(() => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
  
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Cliente/ListaProfissao`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.sucesso === true) {  
          console.log(result);
          for(let i = 0; i < result.profissoes.length; i = i + 1 ) {
            setCargo(Cargo => [...Cargo, {
              value: result.profissoes[i].cad_cod,
              label: result.profissoes[i].cad_descricao
            }])
          }
        }
      })
      .catch(error => console.log('error', error));

  },[]);
  
  useEffect(() => {
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Pesquisa/ListarCanalCliente`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result)
        if(result.sucesso === true) {
          setListaCanalCliente(result.outCanalCliente);
        }
      })
      .catch(error => console.log('error', error));

  },[]);

  const GreenRadio = withStyles({
    root: {
      color: '#DDDDDD',
      "&$checked": {
        color: '#FFFFFF'
      }
    },
    checked: {}
  })((props) => <Radio color="default" {...props} />);
  
  return (
    <>  
    
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

            { ClienteMostra == true ? <MostraBuscaCliente /> : null }
              { ProdutoMostra == true ? <MostraProdutoCliente /> : null }
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Pesquisa Indireto</TitNoticias>
                    <Clear />

                    <TextoDescPesquisa>Formulário para pesquisa de preços.</TextoDescPesquisa>
                    <Clear />


                    <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { TipoPesquisa: 2 } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(onSubmit)}>

                        <DescCampo>Dados do cliente</DescCampo>
                        {ClienteSelecionado == false ? 
                            <CampoFormBusca>
                                <Controller
                                    control={control}
                                    ref={register}
                                    id="c_razaosap"
                                    name="c_razaosap"
                                    type="text"
                                    placeholder={'Razão social ou SAP'}
                                    className="CampoForm CampoFormLogin"
                                    as={InputMask}
                                    mask=""
                                />
                                <BtIcoBuscar onClick={handleSubmit(BuscaCliente)}><img src={IcoBusca} /></BtIcoBuscar>
                            </CampoFormBusca>
                        :
                            <ClienteProdutoSelecionado>
                                <div className={'NomeCliente'}>{ClienteNome}</div>
                                <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(ClienteCPNJ)}</div>
                                <div className={'CNPJSAP'}><span>SAP</span> {ClienteSAP}</div>
                                <div className={'BtAlterar'} onClick={()=>setClienteSelecionado(false)}>ALTERAR</div>
                            </ClienteProdutoSelecionado>
                        }


                        <br />
                        <CampoFormCadastro>
                          <DescCampo>Canal cliente</DescCampo>
                          <aside>                          
                          <RadioGroup aria-label="gender" name="gender1" value={Number(CanalCliente)} onChange={(e)=>setCanalCliente(e.target.value)}>
                          {
                            ListaCanalCliente.map((item, key) => {
                              return <><FormControlLabel value={item.id} control={<GreenRadio color="primary" />} label={item.descricao}/> </>
                            })
                          }
                          </RadioGroup>
                          </aside>                          
                        </CampoFormCadastro>


                        <br />
                        <DescCampo>Sobre a compra</DescCampo>


                        {ProdutoSelecionado == false ? 
                            <CampoFormBusca>
                                <Controller
                                    control={control}
                                    ref={register}
                                    id="c_industria"
                                    name="c_industria"
                                    type="text"
                                    placeholder={'Indústria, marca ou SKU'}
                                    className="CampoForm CampoFormLogin"
                                    as={InputMask}
                                    mask=""
                                />
                                <BtIcoBuscar onClick={handleSubmit(BuscaIndustria)}><img src={IcoBusca} /></BtIcoBuscar>
                            </CampoFormBusca>
                        :
                            <ClienteProdutoSelecionado>
                                <div className={'NomeCliente'}>{ProdutoNome}</div>
                                <div className={'MarcaCategoriaPeso'}><span>Marca</span> {ProdutoMarca}</div>
                                <div className={'MarcaCategoriaPeso'}><span>Categoria</span> {ProdutoCategoria}</div>
                                <div className={'MarcaCategoriaPeso'}><span>Peso</span> {ProdutoPeso}</div>
                                <div className={'BtAlterar'} onClick={()=>setProdutoSelecionado(false)}>ALTERAR</div>
                            </ClienteProdutoSelecionado>
                        }


                        <DescCampo>Preço unitário (por saco/balde/caixa)</DescCampo>
                        <CampoFormCadastro>
                            <CurrencyInput
                                id="c_preco"
                                name="c_preco"
                                prefix="R$ "
                                decimalSeparator=","
                                thousandSeparator="."
                                maxlength="10"
                                value={PrecoPao}
                                onChange={(_, valor) => setPrecoPao(valor)}
                            />
                        </CampoFormCadastro>


                        
                        <Clear />
                        <br />



                        
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">ENVIAR PESQUISA</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />


                        </FormPesquisa>



                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default IndiretoPesquisa;
